module.exports = __webpack_public_path__ + "mobile/img/crm-img12.e130fea8.png";